import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ce25750"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder", "value"]

import { LayoutTypes } from "@/store/app/state";
import { Attachment } from "@/store/chats/types";
import { ref } from "vue";
import { useHandleModifyMessageInputHeight } from "./useHandleModifyMessageInputHeight";

interface Props {
  attachments: Attachment[];
  text: string;
}

interface Emits {
  (e: "update-text", text: string): void;
  (e: "send-message"): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
    attachments: { default: () => [] },
    text: { default: "" }
  },
  emits: ["update-text", "send-message"],
  setup(__props: any, { emit: __emit }) {

const root = ref<HTMLElement>();
const props = __props;
const emit = __emit;
const { layoutType, messageInputHeight, attachmentsHeightAddition } =
  useHandleModifyMessageInputHeight(props, root);

const updateText = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit("update-text", target.value);
};
const handleEnter = (e: KeyboardEvent) => {
  if (e.shiftKey || layoutType.value === LayoutTypes.MOBILE) return;
  emit("send-message");
  e.preventDefault();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    ref_key: "root",
    ref: root,
    style: _normalizeStyle({
      height: `${_unref(messageInputHeight) - 24 - _unref(attachmentsHeightAddition)}px`,
    }),
    placeholder: _ctx.$t('chat.chatContainer.InputBar.placeholder'),
    value: _ctx.text,
    onInput: updateText,
    onKeydown: _withKeys(handleEnter, ["enter"])
  }, null, 44, _hoisted_1))
}
}

})